module.exports = __webpack_public_path__ + "img/solution-data-logo7.18b721fc.png";